// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  leaseId: __t.u64().primaryKey().name("lease_id"),
  unitRowId: __t.u64().name("unit_row_id"),
  structureId: __t.u64().name("structure_id"),
  unitId: __t.string().name("unit_id"),
  tenant: __t.identity(),
  tenantName: __t.string().name("tenant_name"),
  landlord: __t.identity(),
  rentPerDay: __t.u32().name("rent_per_day"),
  since: __t.timestamp(),
  paidDays: __t.u32().name("paid_days"),
  releasedDays: __t.u32().name("released_days"),
  paidUntil: __t.timestamp().name("paid_until"),
  heldSov: __t.i64().name("held_sov"),
  noticeAt: __t.timestamp().name("notice_at"),
  endsAt: __t.timestamp().name("ends_at"),
  state: __t.string(),
  endedAt: __t.timestamp().name("ended_at"),
  entryPermId: __t.u64().name("entry_perm_id"),
});
